var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPermission.settings.view)?_c('div',{staticClass:"print"},[_c('md-tabs',{staticClass:"version-tabs",attrs:{"md-sync-route":""}},[_c('md-tab',{attrs:{"id":"tab-version_web","md-label":"Web","to":"/version/web"}}),_c('md-tab',{attrs:{"id":"tab-version_app","md-label":"App","to":"/version/app"}})],1),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }